import React from "react";

import { useT } from "../i18n";
import { useTemplateVars } from "../i18n/vars";
import Seo from "../components/Seo";
import PageHero from "../components/blocks/PageHero";
import LegalDocument from "../components/blocks/LegalDocument";

// Terms and Privacy share a component: both are a hero, a last-updated stamp
// and a numbered document with a contents rail.

export default function LegalPage({ doc }) {
  const { t } = useT();
  const vars = useTemplateVars();
  const base = `legal.${doc}`;

  return (
    <>
      <Seo title={t(`${base}.seoTitle`)} description={t(`${base}.seoDescription`, vars)} />

      <PageHero
        eyebrow={t("legal.eyebrow")}
        title={t(`${base}.title`)}
        lede={t(`${base}.lede`, vars)}
        meta={{ label: t("legal.lastUpdatedLabel"), value: t("legal.lastUpdated") }}
      />

      <LegalDocument doc={doc} />
    </>
  );
}
